import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Country, County, State } from '../models/case/case.interface';
import {
  PaginatedData,
  PaginatedDataResponse,
} from '../models/common/common.interface';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private http: HttpClient) {}

  getCountries(
    limit: number,
    offSet: number,
    searchTerm?: string
  ): Observable<PaginatedDataResponse<PaginatedData<Country>>> {
    return this.http.get<PaginatedDataResponse<PaginatedData<Country>>>(
      `${environment.fireStoreApiUrl}/api/v1/country/?limit=${limit}&offset=${offSet}&search=${searchTerm}`
    );
  }

  getStates(
    limit: number,
    offSet: number,
    searchTerm?: string
  ): Observable<PaginatedDataResponse<PaginatedData<State>>> {
    return this.http.get<PaginatedDataResponse<PaginatedData<State>>>(
      `${environment.fireStoreApiUrl}/api/v1/state/?limit=${limit}&offset=${offSet}&search=${searchTerm}`
    );
  }

  getCounties(
    limit: number,
    offSet: number,
    state_id: number,
    searchTerm?: string
  ): Observable<PaginatedDataResponse<PaginatedData<County>>> {
    return this.http.get<PaginatedDataResponse<PaginatedData<County>>>(
      `${environment.fireStoreApiUrl}/api/v1/county/?limit=${limit}&offset=${offSet}&search=${searchTerm}&state_id=${state_id}`
    );
  }
}
